import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import InputWithButton from 'components/common/InputWithButton';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div style={{ marginBottom: 24 }}>
          <h3 className="aboutUsTypographyHeaderLarge">Input With Button</h3>
          <p>
            <>
              An component with an input text box with a button directly next to
              the component. Customisable with a inputValue, inputPlaceholder,
              buttonColor, buttonStyle, onClickButton.
            </>
          </p>
        </div>
        <div style={{ marginBottom: '24px' }}>
          <p style={{ marginBottom: '16px', fontWeight: 'bold' }}>
            Simple, text no button, default width
          </p>
          <InputWithButton inputValue="https://www.daymade.co.uk" hideButton />
        </div>
        <div style={{ marginBottom: '24px' }}>
          <p style={{ marginBottom: '16px', fontWeight: 'bold' }}>
            With button, default min-width
          </p>
          <InputWithButton
            inputValue="https://www.daymade.co.uk"
            onClickButton={() => console.log('clicked')}
            buttonText="copy"
          />
        </div>
        <div
          style={{
            /** @ts-ignore */
            '--inputWithButton-min-width': '500px',
            marginBottom: '24px',
          }}
        >
          <p style={{ marginBottom: '16px', fontWeight: 'bold' }}>
            With button, custom min-width using --inputWithButton-min-width
            variable
          </p>
          <InputWithButton
            inputValue="https://www.daymade.co.uk"
            onClickButton={() => console.log('clicked')}
            buttonText="submit"
          />
        </div>
        <div
          style={{
            /** @ts-ignore */
            '--inputWithButton-width': '100%',
            width: '100%',
            marginBottom: '24px',
          }}
        >
          <p style={{ marginBottom: '16px', fontWeight: 'bold' }}>
            With button, custom width using --inputWithButton-width variable
          </p>
          <InputWithButton
            inputValue="https://www.daymade.co.uk"
            onClickButton={() => console.log('clicked')}
            buttonText="invite"
          />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Input with Button',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
